module.exports = __webpack_public_path__ + "img/shop1_1.b905da0c.png";